import { CollectionApiResponse } from 'api/api.types';
import {
  Box,
  Flex,
  StyleProps,
  color,
  spacing,
  useColorMode,
  useIsMobileView,
} from 'deepstash-ui';
import React from 'react';
import LandingStartTrialSection from 'src/page-components/landing/components-v2/LandingStartTrialSection';

// TODO No Trial Changes
// const AuthButtons = dynamic(() => import('src/components/auth/AuthButtons'), {
//   ssr: false,
// });

// We disabled the custom journey blocker for now
// const COLLECTION_IMAGE_SIZE = { WIDTH: 140, HEIGHT: 170, BORDER_RADIUS: 16 };

interface SourceNSIArticleGradientProps {
  underlineColor?: string;
  collection?: CollectionApiResponse;
}

const SourceNSIArticleGradient: React.FC<
  SourceNSIArticleGradientProps & StyleProps
> = ({ collection, ...props }) => {
  const { colorMode } = useColorMode();
  const isMobileView = useIsMobileView();
  // const router = useRouter();

  // We make the gradientFooterRef absolute after scrolling past a point.
  const gradientFooterRef = React.useRef<HTMLDivElement>(null);

  // const collectionSlug = React.useMemo(() => {
  //   if (collection === undefined) {
  //     return '';
  //   }
  //   return slugify(collection.name);
  // }, [collection]);

  // const collectionPageRoute = `/collection/${collection?.id}/${collectionSlug}`;

  // const minutesToRead = React.useMemo(() => {
  //   if (collection?.time_to_read !== undefined) {
  //     return formatSecondsToNearestMinute(collection.time_to_read);
  //   }
  //   return undefined;
  // }, [collection]);

  return (
    <Box position="absolute" ref={gradientFooterRef} height="100%" width="100%">
      <Flex
        // position={gradientFooterPosition === 'fixed' ? 'fixed' : 'absolute'}
        position={'absolute'}
        zIndex={5}
        bottom={0}
        left={0}
        top="unset"
        right={0}
        width="100%"
        height={{ base: spacing.toRem(480), md: spacing.toRem(600) }}
        background={`linear-gradient(to top,  ${color[colorMode].background} ${
          isMobileView ? 75 : 60
        }%,${color.transparent} 100%)`}
        flexDirection="column"
        justifyContent={collection === undefined ? 'flex-end' : 'center'}
        alignItems="center"
        pb={spacing.toRem(8)}
        {...props}
      >
        {/* {collection === undefined ? ( */}
        <Flex
          px={spacing.toRem(16)}
          flexDirection={'column'}
          alignItems="center"
        >
          {/* <Flex w="auto" position="relative">
              <Flex position="relative">
                <PrimaryText
                  color={color[colorMode].text}
                  mb={spacing.M.rem}
                  textAlign="center"
                  {...typography.primaryHeadingFonts.small.bold}
                  zIndex={1}
                >
                  {actionStrings.keepReading}
                </PrimaryText>
                <UnderlineMarkerDrawing
                  position="absolute"
                  top="0.9rem"
                  left={0}
                  height="35%"
                  zIndex={0}
                  fill={underlineColor}
                />
              </Flex>

              <UnderlineMarkerDrawing
                height={'13px'}
                fill="none"
                zIndex={-1}
                top={16}
                position="absolute"
              />
            </Flex> */}
          {/* <AuthButtons /> */}
          <LandingStartTrialSection isCentered />
        </Flex>
        {/* ) : (
          <Flex
            flexDirection={'row'}
            // bgColor="red"
            width={'100%'}
            p={24}
            gridColumnGap={16}
            zIndex={1}
          >
            <NextImage
              wrapperStyle={{
                width: COLLECTION_IMAGE_SIZE.WIDTH,
                height: COLLECTION_IMAGE_SIZE.HEIGHT,
                borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
                cursor: 'pointer',
              }}
              imageUrl={collection.image}
              blurhash={collection.image_blurhash}
              alt={`${collection.name}`}
              priority={false}
              onClick={() => {
                router.push(collectionPageRoute);
              }}
            />
            <Flex flexDirection="column" flex={1}>
              <PrimaryText
                color={color[colorMode].text}
                {...typography.primaryHeadingFonts.small.regular}
              >
                {`Discover ${collection.total_blocks} similar ideas in`}
              </PrimaryText>

              <NextLink href={collectionPageRoute} passHref>
                <Link
                  _focus={undefined}
                  _hover={{ textDecoration: 'underline' }}
                >
                  <PrimaryText
                    color={color[colorMode].text}
                    {...typography.primaryHeadingFonts.medium.bold}
                    zIndex={1}
                  >
                    {collection.name}
                  </PrimaryText>
                </Link>
              </NextLink>
              {minutesToRead !== undefined ? (
                <Flex
                  flexDirection="row"
                  alignItems="center"
                  mt={8}
                  flexWrap="wrap"
                >
                  <Text
                    {...typography.primaryTextFonts.large.regular}
                    color={color[colorMode].textSecondary}
                  >{`It takes just`}</Text>

                  <Flex
                    boxSize={'24px'}
                    alignItems="center"
                    justifyContent="center"
                    ml={8}
                    mr={4}
                  >
                    <ClockIconSvg
                      width={24}
                      height={24}
                      color={color[colorMode].textSecondary}
                    />
                  </Flex>
                  <Text
                    {...typography.primaryTextFonts.large.regular}
                    color={color[colorMode].textSecondary}
                  >
                    {`${minutesToRead} to read`}
                  </Text>
                </Flex>
              ) : null}
            </Flex>
          </Flex>
        )} */}
      </Flex>
    </Box>
  );
};

export default SourceNSIArticleGradient;
